import React, { useEffect, useState } from "react";
import api from "../../api/client";
import Header from "../../components/layout/Header";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";

// Cadastro de cidades de referência: cada cidade tem um ajuste (%) padrão aplicado sobre a
// venda quando selecionada na precificação da proposta.
export default function Cidades() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try { setItems((await api.get("/cidades")).data); }
    catch (e) { toast.error("Falha ao carregar cidades"); }
  };
  useEffect(() => { load(); }, []);

  const upd = (i, k, v) => { const list = [...items]; list[i] = { ...list[i], [k]: v }; setItems(list); };

  const save = async (i) => {
    const it = items[i];
    try {
      await api.put(`/cidades/${it.id}`, {
        nome: it.nome, uf: it.uf || "", ajuste_pct: parseFloat(it.ajuste_pct || 0), observacao: it.observacao || "",
      });
      toast.success("Cidade salva"); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao salvar"); }
  };

  const add = async () => {
    const nome = window.prompt("Nome da cidade (ex.: Rio de Janeiro):");
    if (!nome) return;
    const uf = (window.prompt("UF (ex.: RJ):") || "").toUpperCase();
    const pct = parseFloat(window.prompt("Ajuste de preço (%) — ex.: 30:") || "0");
    try {
      await api.post("/cidades", { nome, uf, ajuste_pct: isNaN(pct) ? 0 : pct, observacao: "" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao criar"); }
  };

  const del = async (id) => {
    if (!window.confirm("Excluir esta cidade?")) return;
    try { await api.delete(`/cidades/${id}`); load(); } catch (e) { toast.error("Falha ao excluir"); }
  };

  return (
    <>
      <Header title="Cidades de Referência" subtitle={`${items.length} cidade(s) — ajuste de preço por praça`}
        actions={<Button onClick={add} data-testid="add-cidade-btn"><Plus className="size-4 mr-1" /> Nova</Button>} />
      <div className="p-8" data-testid="cidades-page">
        <div className="border border-border rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-muted/30">
              <tr>
                <th className="text-left px-4 py-3 label-tech">Cidade</th>
                <th className="text-left px-4 py-3 label-tech">UF</th>
                <th className="text-right px-4 py-3 label-tech">Ajuste (%)</th>
                <th className="text-left px-4 py-3 label-tech">Observação</th>
                <th className="text-right px-4 py-3 label-tech">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {items.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-6 text-center text-muted-foreground">Nenhuma cidade cadastrada. Clique em “Nova”.</td></tr>
              )}
              {items.map((it, i) => (
                <tr key={it.id} data-testid={`cidade-row-${it.id}`}>
                  <td className="px-4 py-3"><Input value={it.nome} onChange={(e) => upd(i, "nome", e.target.value)} /></td>
                  <td className="px-4 py-3"><Input className="w-20 uppercase" value={it.uf || ""} onChange={(e) => upd(i, "uf", e.target.value.toUpperCase())} /></td>
                  <td className="px-4 py-3 text-right"><Input className="w-24 ml-auto text-right font-mono" type="number" step="1" value={it.ajuste_pct} onChange={(e) => upd(i, "ajuste_pct", parseFloat(e.target.value || 0))} /></td>
                  <td className="px-4 py-3"><Input value={it.observacao || ""} onChange={(e) => upd(i, "observacao", e.target.value)} /></td>
                  <td className="px-4 py-3 text-right">
                    <Button variant="ghost" size="sm" onClick={() => save(i)} data-testid={`cidade-save-${it.id}`}><Save className="size-4" /></Button>
                    <Button variant="ghost" size="sm" onClick={() => del(it.id)} data-testid={`cidade-delete-${it.id}`}><Trash2 className="size-4 text-destructive" /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
